
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { 
  Users, 
  Store, 
  BarChart3, 
  CreditCard, 
  HandshakeIcon, 
  HelpCircle, 
  RefreshCw,
  ExternalLink
} from "lucide-react";
import { Link } from "react-router-dom";

const AdminDashboardLinks = () => {
  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex flex-wrap items-center gap-3">
          <Button 
            variant="outline" 
            size="sm" 
            asChild
          >
            <Link to="https://supabase.com/dashboard" target="_blank" rel="noopener noreferrer">
              <ExternalLink className="h-4 w-4 mr-2" />
              Supabase
            </Link>
          </Button>
          
          <Button 
            variant="outline" 
            size="sm" 
            asChild
          >
            <Link to="https://dashboard.stripe.com" target="_blank" rel="noopener noreferrer">
              <ExternalLink className="h-4 w-4 mr-2" />
              Stripe
            </Link>
          </Button>
          
          <Button 
            variant="outline" 
            size="sm" 
            asChild
          >
            <Link to="https://resend.com/overview" target="_blank" rel="noopener noreferrer">
              <ExternalLink className="h-4 w-4 mr-2" />
              E-Mails
            </Link>
          </Button>
          
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => window.location.reload()}
          >
            <RefreshCw className="h-4 w-4 mr-2" />
            Dashboard neu laden
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default AdminDashboardLinks;
